var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFriend = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2134 14.4937C12.0801 14.4803 11.9201 14.4803 11.7734 14.4937C8.60008 14.387 6.08008 11.787 6.08008 8.58699C6.08008 5.32033 8.72008 2.66699 12.0001 2.66699C15.2667 2.66699 17.9201 5.32033 17.9201 8.58699C17.9067 11.787 15.3867 14.387 12.2134 14.4937Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8804 5.33301C24.467 5.33301 26.547 7.42634 26.547 9.99967C26.547 12.5197 24.547 14.573 22.0537 14.6663C21.947 14.653 21.827 14.653 21.707 14.6663",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54695 19.413C2.32029 21.573 2.32029 25.093 5.54695 27.2397C9.21362 29.693 15.227 29.693 18.8936 27.2397C22.1203 25.0797 22.1203 21.5597 18.8936 19.413C15.2403 16.973 9.22695 16.973 5.54695 19.413Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4531 26.667C25.4131 26.467 26.3198 26.0803 27.0665 25.507C29.1465 23.947 29.1465 21.3737 27.0665 19.8137C26.3331 19.2537 25.4398 18.8803 24.4931 18.667",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFriend, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/friend.395be83a.svg";
export { ForwardRef as ReactComponent };